import { Component } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FieldType } from '@ngx-formly/core';
@Component({
    selector: 'tooltip',
    template: `<div>
		<mat-icon matTooltip="{{ to.label }}" color="primary">info</mat-icon>
	</div>`,
    standalone: true,
    imports: [MatIconModule, MatTooltipModule],
})
export class TooltipComponent extends FieldType {}
